import { useFichaSecao } from "./use-ficha-secao";
import { FichaSecaoView } from "./view-ficha-secao";
import type { FichaSecaoProps } from "./types-ficha-secao";

export function FichaSecao(props: FichaSecaoProps) {
  const vm = useFichaSecao(props);

  return <FichaSecaoView {...vm} />;
}

export type * from "./types-ficha-secao";
